import React, { useEffect } from 'react';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';
import CustomLink from '../../components/CustomLink';
import { Icon } from '../../components/Icon';
import { useDocumentTitle } from '../../shared/use-document-title';
import { useAuthForm } from '../../shared/use-auth-form';
import { createIssueReportLink } from '../../../lib/shared/link';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import mainImageSrc from '../../assets/images/main-v2.png';
import styles from './SignInPage.css';

function SignInPage() {
    const {isPending, isSuccessful, changeField, submitForm, fields, errors} = useAuthForm();

    useEffect(() => {
        logEvent(EVENT_TYPES.SIGN_IN_PAGE_VISITED);
    }, []);

    useDocumentTitle('Sign In');

    return (
        <main
            className={styles.root}
            style={{backgroundImage: `url(${mainImageSrc})`}}
        >
            <div className={styles.wrapper}>
                <form className={styles.form}>
                    <h1 className={styles.title}>Sign in</h1>
                    <div className={styles.formWrapper}>
                        {isSuccessful
                            ? (
                                <>
                                    <Icon name='key' className={styles.successfulIcon} />
                                    <p className={styles.successfulText}>
                                        We've sent a login link to <strong>{fields.email}</strong> — check your inbox and follow it.<br /><br />
                                        <strong>Feel free to close this tab.</strong>
                                    </p>
                                </>
                            )
                            : (
                                <>
                                    <Input
                                        value={fields.email}
                                        name='email'
                                        onChange={changeField}
                                        className={styles.input}
                                        label='Email address'
                                        placeholder='mail@example.com'
                                        errorText={errors.email}
                                        disabled={isSuccessful || isPending}
                                        inputProps={{autoComplete: 'email', type: 'email'}}
                                    />
                                    {Boolean(errors.form) && (
                                        <p className={styles.error}>{errors.form}</p>
                                    )}
                                    <Button
                                        label='Continue'
                                        onClick={submitForm}
                                        className={styles.button}
                                        isLoading={isPending}
                                        disabled={isSuccessful}
                                    />
                                </>       
                            )
                        }
                    </div>
                    <p className={styles.issueReportText}>
                        Having trouble or need help signing in? <br />
                        <CustomLink
                            to={createIssueReportLink()}
                        >
                            Report an issue
                        </CustomLink>
                    </p>
                </form>
            </div>
        </main>
    )
};

export {
    SignInPage
};
